// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__JaLxq","info":"PatientInfo_info__mMJfb"};